var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 0.833344H4.66634L6.89967 11.9917C6.97588 12.3753 7.1846 12.72 7.4893 12.9653C7.79399 13.2105 8.17526 13.3408 8.56634 13.3333H16.6663C17.0574 13.3408 17.4387 13.2105 17.7434 12.9653C18.0481 12.72 18.2568 12.3753 18.333 11.9917L19.6663 5.00001H5.49967M8.83301 17.5C8.83301 17.9602 8.45991 18.3333 7.99967 18.3333C7.53944 18.3333 7.16634 17.9602 7.16634 17.5C7.16634 17.0398 7.53944 16.6667 7.99967 16.6667C8.45991 16.6667 8.83301 17.0398 8.83301 17.5ZM17.9997 17.5C17.9997 17.9602 17.6266 18.3333 17.1663 18.3333C16.7061 18.3333 16.333 17.9602 16.333 17.5C16.333 17.0398 16.7061 16.6667 17.1663 16.6667C17.6266 16.6667 17.9997 17.0398 17.9997 17.5Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.7d33338284ccad2194a94f71a084fc8b.svg";
export { ForwardRef as ReactComponent };